import React from 'react'

const Home2 = () => {
  return (
    <>
    
      <h1>This is Home2 page</h1>
      <button className='btn btn-success'>Hello</button>
    </>
  )
}

export default Home2
